export default __webpack_public_path__ + "static/media/shruti_singh.39649c95.jpg";